/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

const fetch = async (id: string, isList = false) => {
    const workers = await apiInputService.get(`/frontend/workers/consolidatedWorkerId/${id}`, {
        params: {
            isList
        }
    })
    const { data } = workers;

    return data;
}


export const useWorkersByCWEntityID = (id: string, isList = false, options?: any) => {
    return useQuery<any[]>(["workers-cw", id, isList], () => fetch(id, isList), {
        enabled: !!id,
        ...options,
        
    });
}